module.exports = __webpack_public_path__ + "img/27.519c7e15.png";